import React from 'react';
import { connect } from 'react-redux';
import TagSelect from 'components/TagSelect';
import { Select } from 'antd';
import { changeAsset } from 'modules/auth';
import PropTypes from 'prop-types';
import axios from 'axios';

const Option = Select.Option;

class TagSelectContainer extends React.Component {
  static propTypes = {
    asset: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    currentTags: PropTypes.array.isRequired,
    removeTag: PropTypes.func.isRequired,
    colors: PropTypes.objectOf(PropTypes.string).isRequired,
    dChangeAsset: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };
  }

  onSelect = rawTags => {
    rawTags.forEach(t => {
      if (this.props.currentTags.find(v => v.value === t.value)) {
        // This is already selected, unselect.
        this.props.removeTag(t.value);
      } else {
        this.props.onSelect(t);
      }
    });
  };

  loadOptions = async input => {
    if (input.length === 0) {
      return {
        options: [],
      };
    }
    const result = await axios.get(
      // `http://localhost:8001/tagsearch?q=${input}&asset=${
      `https://opin-api.cognite.ai/tagsearch?q=${input}&asset=${'AKSO'}&limit=100&project=akso`
    );
    return {
      options: result.data.map(option => ({
        ...option,
        description: option.label || null,
        label: `${option.label ? option.label : ''} (${option.value})`,
      })),
    };
  };
  render() {
    const { asset, dChangeAsset } = this.props;
    return (
      <div>
        <Select
          style={{ marginBottom: '15px', width: '100%' }}
          value={asset}
          onChange={a => dChangeAsset(a)}
        >
          <Option value="root">Root</Option>
        </Select>
        <TagSelect
          asset={this.props.asset}
          loadOptions={this.loadOptions}
          onChange={this.onSelect}
          value={this.props.currentTags}
          currentTags={this.props.currentTags}
          colors={this.props.colors}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    asset: state.auth.asset || 'VAL',
  }),
  dispatch => ({
    dChangeAsset: asset => dispatch(changeAsset(asset)),
  })
)(TagSelectContainer);



// WEBPACK FOOTER //
// ./src/containers/TagSelectContainer.js